import { Box } from "@mui/system";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { RouteParamsProvider } from "../context/RouteParamsProvider";
import { SelectedOptionsProvider } from "../context/SelectedOptionsContext";
import { Analytics } from "@vercel/analytics/react";

import "./index.css";
import styles from "./app.module.scss";

import { WrapperUI } from "../components/WrapperUI";

const theme = createTheme({
  typography: {
    fontFamily:
      '"Onest", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
    color: "#282823",
  },
  // Extra safety: reinforce on <body> via CssBaseline
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily:
            '"Onest", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
        },
      },
    },
  },
  borderRadius: {
    default: "8px 8px 8px 2px",
    small: "6px 6px 6px 1px",
    big: "20px 20px 20px 4px",
  },
  palette: {
    companyColors: {
      neutral: "#ffffff",
      neutralRGB: "255,255,255",
      primary: "#ED6B45",
      secondary: "#282823",
      secondaryRGB: "40,40,35",
      accent: "#EA3031",
      greyLight1: "#A3A3A0",
      greyLight2: "#D9D9D9",
      greyLight3: "#E8E8E8",
      opacity0: 0,
      opacity25: 0.25,
      opacity50: 0.5,
      opacity75: 0.75,
    },
  },
});

export function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Analytics />
      <SelectedOptionsProvider>
        <Box className={styles.app}>
          <Router>
            <Routes>
              <Route
                path="/"
                element={
                  <RouteParamsProvider>
                    <WrapperUI />
                  </RouteParamsProvider>
                }
              />
              <Route
                path="/:configCode"
                element={
                  <RouteParamsProvider>
                    <WrapperUI />
                  </RouteParamsProvider>
                }
              />
            </Routes>
          </Router>
        </Box>
      </SelectedOptionsProvider>
    </ThemeProvider>
  );
}

export default App;
